import Service from './service'
import store from '../store'
import Axios from 'axios'

export default class DetailService {
  /**
   * Permet de récupérer tous les détails commentés par un enseignant spécifique
   * @param {string} login
   */
  static async getPendingRemediation (login) {
    try {
      await Service.verifyToken()
      return Service.api.get(`/detail/${login}`, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Modifie un détail spécifique.
   * La syntaxe de requête Axios pour les méthodes DELETE et PUT est différente de POST et GET
   * @param {Object} params
   */
  static async editDetail (params) {
    try {
      await Service.verifyToken()
      return await Axios({
        method: 'put',
        url: `${Service.url}/detail`,
        data: { ...params },
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Crée un détail pour le travail spécifié en paramètre.
   * @param {Object} params
   */
  static async createDetail (params) {
    try {
      await Service.verifyToken()
      return await Service.api.post('/detail', {
        ...params
      }, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Supprime un détail spécifié en paramètre.
   * La syntaxe de requête Axios pour les méthodes DELETE et PUT est différente de POST et GET
   * @param {string} numero
   */
  static async removeDetail (numero) {
    try {
      await Service.verifyToken()
      return await Axios({
        method: 'delete',
        url: `${Service.url}/detail`,
        data: { numero: numero },
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
}
